module.exports = __webpack_public_path__ + "img/Thailand-3-hover.9f30786a.jpg";